export default {
    DEFAULT_ACTION: 'member/default'
};
